import styled, { css } from 'styled-components'

import { CustomButton } from '../../../styles/global'
import { CardContainer, CardSkeleton } from '../../../components/Card/styles'

export const Container = styled.div`
  width:100%;
  padding: 1rem;
  margin:0 auto;
`

export const List = styled.div`
  width: 100%;
  position: relative;
`

export const Title = styled.h3`
  font-family: 'Nunito';
  font-weight: 600;
  font-size: 20px;
  line-height: 120%;
  display: flex;
  letter-spacing: 0.96px;
  color: #222;
  padding: 16px 0 16px 0;
`

export const StyledCard = styled.div`
  display: flex;
  height: 100%;
  margin-bottom: 16px;

  ${CardContainer}{
    flex-direction: row;
    justify-content: space-between;
    box-sizing: border-box;
    align-items: center;
    width: 100%;
    border: 1px solid #DADADA;
    box-shadow: none;
    gap: 16px;
  }
  ${CardSkeleton}{
    min-height: 137px;
  }
`

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  min-width: 56%;
  max-width: 100%;
`

export const Subtitle = styled.h2`
  color: #222;
  font-family: 'Nunito';
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.96px;
  margin-bottom: 4px;

  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  white-space: pre-wrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;

  ${(isRead) => isRead && css`
    color: #555;
  `}
`

export const Text = styled.p`
  color: #222;
  font-family: 'Open Sans';
  font-weight: 400;
  font-size: 13px;
  line-height: 19px;
  margin: 0 0 8px 0;

  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  white-space: pre-wrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;

  ${(isRead) => isRead && css`
    color: #555;
  `}
`

export const Avatar = styled.img`

`

export const ButtonOpen = styled.button`
  margin:0 auto;
  border:none;
  background:none;
`

export const ButtonToClose = styled(ButtonOpen)`

`

export const DateField = styled.div`
  font-family: 'Open Sans';
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  color: #555;
`

export const Button = styled(CustomButton)`

`

export const WarningLabel = styled.div`
  width: fit-content;
  display: flex;
  align-items: center;
  padding: 2px 8px 3px;
  background-color: #FAECCA;
  margin-bottom: 11px;
  border-radius: 8px;
  gap: 5px;
`

export const WarningText = styled.h2`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 145%;
  color: #CE9400;
  margin-bottom: 0;
`
